// extracted by mini-css-extract-plugin
export var planCard = "_va-0";
export var planList = "_va-1";